import React from "react";

import digiLockerLogo from '../../../../../../Assets/digiLockerLogo.jpeg';
import { useImageToBase64 } from "../utlis/useImageToBase64";

const SignatoryImage = ({ url, alt, className }) => {
    const BACKEND_URL = process.env.REACT_APP_ENTERPRISE_BACKEND_URL || "http://localhost:4040";
    const fullUrl = url ? (url.startsWith("http") || url.startsWith("data:") || url.startsWith("blob:") ? url : `${BACKEND_URL}${url}`) : null;
    const base64Url = useImageToBase64(fullUrl);

    if (!fullUrl) return null;
    return <img src={base64Url || fullUrl} alt={alt} className={className} />;
};

export default function SignatureBlock({ state, companyName, finalDrawnSignature, finalSignature, isLastPage }) {
    return (
        <div className="mt-4 w-full break-inside-avoid pb-2 shrink-0">
            {isLastPage && <p className="mb-4 text-slate-900 font-medium">Sincerely,</p>}

            <div className="space-y-1 w-full">
                {state.signatureType !== 'esign' && state.signatureType !== 'send_link' && (
                    <>
                        {state.signatureType === 'draw' && state.drawnSignature && (
                            <img src={finalDrawnSignature || state.drawnSignature} alt="Signature" className="h-16 w-auto object-contain -ml-3" />
                        )}
                        {state.signatureType === 'upload' && state.uploadedSignatureUrl && (
                            <img src={finalSignature || state.uploadedSignatureUrl} alt="Signature" className="h-16 w-auto object-contain -ml-3" />
                        )}
                        <div className="mt-2">
                            <p className="font-bold text-slate-900 text-[12pt] tracking-wide uppercase">{companyName}</p>
                            <p className="text-[10pt] text-slate-500 mt-0.5 uppercase tracking-wider font-semibold">Authorized Signatory</p>
                        </div>
                    </>
                )}

                {state.signatureType === 'send_link' && state.signatories && state.signatories.length > 0 && (
                    <div className="flex flex-wrap items-start gap-x-6 gap-y-6 mt-6 w-full">
                        {state.signatories.map((sig, idx) => {
                            const fileData = sig.signatureFile || sig.SignatureFile || {};
                            const finalSigUrl = fileData.file_path || sig.signature_url;
                            let isEsign = false;
                            let esignMeta = null;

                            if (finalSigUrl && finalSigUrl.startsWith('ESIGN::')) {
                                isEsign = true;
                                try { esignMeta = JSON.parse(finalSigUrl.replace('ESIGN::', '')); } catch (e) { }
                            }

                            return (
                                <div key={sig.id || idx} className="flex flex-col items-start min-w-[150px] break-inside-avoid">
                                    <div className="h-[75px] flex items-end justify-start mb-2 w-full">
                                        {isEsign && esignMeta ? (
                                            <div className="border border-[#4a2bae] border-b-[3px] rounded-lg overflow-hidden bg-white w-[300px] shadow-sm">
                                                <div className="bg-[#f8fafc] px-3 py-1.5 border-b border-[#e0e7ff] flex items-center gap-2">
                                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#25d366" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                    <span className="text-[#4a2bae] font-bold text-[9px] tracking-widest">DIGITALLY SIGNED</span>
                                                </div>
                                                <div className="p-2.5 flex justify-between items-center">
                                                    <div>
                                                        <p className="text-slate-900 font-bold text-[11px] m-0 mb-1">{esignMeta.signerName}</p>
                                                        <p className="text-blue-800 font-medium text-[8px] m-0 mb-0.5">Date: {esignMeta.signedAt}</p>
                                                        <p className="text-blue-800 font-medium text-[8px] m-0">Provider: {esignMeta.provider}</p>
                                                    </div>
                                                    <img src={digiLockerLogo} alt="DigiLocker" className="h-16 w-auto object-contain" />
                                                </div>
                                            </div>
                                        ) : finalSigUrl ? (
                                            <SignatoryImage url={finalSigUrl} alt={`${sig.name} Signature`} className="max-h-[75px] max-w-[200px] w-auto object-contain" />
                                        ) : (
                                            <div className="h-[50px] w-40 border-b-2 border-slate-300 flex items-end pb-1">
                                                <span className="text-[8pt] text-slate-400 uppercase tracking-wider italic">Pending Signature</span>
                                            </div>
                                        )}
                                    </div>
                                    <p className="font-bold text-slate-900 text-[11pt] tracking-wide uppercase">{sig.name || "Signatory Name"}</p>
                                    <p className="text-[9pt] text-slate-500 mt-0.5 uppercase tracking-wider font-semibold">{sig.role || "Authorized Signatory"}</p>
                                </div>
                            );
                        })}
                    </div>
                )}

                {state.signatureType === 'esign' && state.esignVerified && (
                    <div className="break-inside-avoid mt-6" style={{ border: '1px solid #4a2bae', borderBottom: '4px solid #4a2bae', borderRadius: '8px', overflow: 'hidden', backgroundColor: '#ffffff', width: '300px', display: 'block', fontFamily: 'Arial, sans-serif', boxSizing: 'border-box' }}>
                        <div style={{ padding: '8px 12px', borderBottom: '1px solid #e0e7ff', backgroundColor: '#f8fafc' }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#25d366" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }}>
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                            <span style={{ color: '#4a2bae', fontWeight: 'bold', fontSize: '11px', verticalAlign: 'middle', letterSpacing: '0.05em' }}>DIGITALLY SIGNED</span>
                        </div>
                        <table style={{ width: '100%', borderCollapse: 'collapse', borderSpacing: 0, margin: 0, backgroundColor: '#ffffff' }}>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px 0 12px 12px', verticalAlign: 'middle', width: '70%', border: 'none' }}>
                                        <p style={{ margin: 0, paddingBottom: '5px', color: '#0f172a', fontWeight: 'bold', fontSize: '13px', lineHeight: '1.2' }}>{state.esignSignerName || "Signer Name"}</p>
                                        <p style={{ margin: 0, paddingBottom: '3px', color: '#4338ca', fontSize: '10px', lineHeight: '1.2' }}>Date: {state.esignDate || "2026-03-05 10:30 IST"}</p>
                                        <p style={{ margin: 0, padding: 0, color: '#4338ca', fontSize: '10px', lineHeight: '1.2' }}>Provider: {state.esignProvider || "DigiLocker Verified"}</p>
                                    </td>
                                    <td style={{ padding: '5px 6px 6px 0', verticalAlign: 'middle', width: '30%', textAlign: 'right', border: 'none' }}>
                                        <img src={digiLockerLogo} alt="DigiLocker Verified" style={{ height: '80px', width: 'auto', display: 'inline-block', objectFit: 'contain' }} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}